<template>
<section>
    <div v-if="user && user.team_settings && user.team_settings.config.admin_folder_enabled !== true" class="container pt-5">
        <upgrade-warning-box :feature="'Admin Folder'"></upgrade-warning-box>
    </div>

    <file-list-view
        v-else-if="user && user.is_admin"
        :user="user"
        :share-allowed="false"
        :is_admin_folder="true"
    ></file-list-view>

    <div v-else class="container pt-5">
        <admin-warning-box></admin-warning-box>
    </div>

</section>
</template>
<script>

import { NamespaceService } from '@/services/namespace-service.js'

import fileListView from './filelist-view.vue'
import upgradeWarningBox from '@/components/upgrade_warning_box.vue'
import adminWarningBox from '@/components/admin_feature_warning_box.vue'

export default {
    props: ['user'],
    components: {
        upgradeWarningBox,
        adminWarningBox,
        fileListView
    },
    created(){
        NamespaceService.ns_type = NamespaceService.NS_TYPE_ADMIN_FOLDER
    }

}
</script>

